<template>
	<fieldset
    class="formLine"
    :class="{
      focus: onFocus,
      error: onError,
      active: hasActiveClass,
      'formLine--with-icon': hasIcon
    }"
  >
    <legend
      v-if="label"
      class="text-hidden"
    >
      {{label}}
    </legend>

    <div class="inputBox">
      <label
        class="form-box-label"
        :class="{ active: hasActiveClass }"
        :label="`textInput-${id}`"
      >
        {{ label }}
      </label>

      <input
        v-model="input"
        v-bind="$attrs"
        v-on="$listeners"
        class="form-box-input"
        :ref="id"
        @input="handleInput"
        @focus="handleFocus"
        @blur="handleBlur"
      />
    </div>

    <p
      v-if="errorMessage && hasError"
      v-html="errorMessage"
      class="form-box-errorText"
    />
	</fieldset>
</template>

<script>
export default {
  inheritAttrs: false,

	props: {
		label: {
      type: String,
      default: ""
    },

    hasError: {
      type: Boolean,
      default: false
    },

    errorMessage: {
      type: String,
      default: ""
    },

    hasIcon: {
      type: Boolean,
      default: false
    },

    initialValue: {
      type: [String, Number],
      required: false
    }
  },

	data() {
		return {
			onFocus: false,
      input: this.initialValue || this.mvInput
		}
  },

  watch: {
    mvInput (newVal) {
      this.input = newVal;
    }
  },

  computed: {
    id() {
      return this.$attrs.id;
    },

    onError() {
      return this.hasError;
    },

    hasActiveClass() {
      return !!(this.onFocus || this.input);
    }
  },

	methods: {
		handleFocus() {
			this.onFocus = true;
    },

    handleBlur() {
      if(!this.input) {
        this.onFocus = false;
      }
    },

    handleInput() {
      this.$nextTick(() => {
        this.$emit('input', this.input)
      })
    }
  },
}
</script>

<style lang="stylus" scoped>
.form-box

  &-errorText
    font-size 12px
    line-height 14px
    margin-top 2px
    color #E7505A
</style>
